import { useGetBrand } from './use-get-brand';

export const useIsComerciales = () => {
	const brand = useGetBrand();

	return brand === 'N';
};
